import { render, staticRenderFns } from "./Osa003.vue?vue&type=template&id=a7ec5518&scoped=true"
var script = {}
import style0 from "./Osa003.vue?vue&type=style&index=0&id=a7ec5518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ec5518",
  null
  
)

export default component.exports